// @flow

import React, {useState} from 'react';

import { useTheme } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import commonListTableStyles from './Styles/CommonListTable.Style';

type Props = {
  classes: Object,
  children: Object,
  rowClasses: Object,
  readonly: boolean,
  handleRowClick: Function
}

const ListTableRow = (props: Props) => {
  const {
    children,
    rowClasses,
    readonly,
    handleRowClick
  } = props;

  const [hover, setHover] = useState(false);
  const theme = useTheme();

  const handleRowMouseEnter = (e) => {
    e.stopPropagation();
    if (!readonly) {
      setHover(true);
    }
  };
  
  const handleRowMouseLeave = (e) => {
    e.stopPropagation();
    // log('[ListTableRow] onmouseleave');
    if (!readonly) {
      setHover(false);
    }
  };

  return (
    <TableRow

      className={hover ? 'hover' : null}
      sx={{
        ...commonListTableStyles.feedTableRow(theme),
        ...(!readonly ? commonListTableStyles.cursorPointer : {}),
        ...rowClasses
      }}
      // className={classNames(
      //   rowClasses,
      //   classes.feedTableRow,
      //   hover ? 'hover' : null,
      //   !readonly ? classes.cursorPointer : null
      // )}
      onClick={!readonly ? handleRowClick : null}
      onMouseEnter={handleRowMouseEnter}
      onMouseLeave={handleRowMouseLeave}
    >
      {children}
    </TableRow>
  );
};

export default ListTableRow;